<div id="content-wrapper" class="container">
	<div class="row align-items-center justify-content-center" style="height:calc(100vh - 166px);">
		<div class="col col-lg-6">

			<div class="card shadow">
				<h5 class="card-header">Elfelejtett jelszó</h5>
				<div class="card-body container-fluid">
					<p>Ha elfelejtette a jelszavát, írja be az alábbi mezőbe fiókazonosítóját, majd kattintson a "Jelszó visszaállítása" gombra. Rendszerünk a fiókjához tartozó e-mail címre megküldi a jelszó megújításához szükséges linket, amelyre kattintva lehet majd új jelszót megadni.</p>
					<%- include('/ui/form', {
						params: [ 'password_reset', form_data, {
							width: 500
						} ],
						fields: [
							{ type: 'row', fields: [
								{ type: 'col', fields: [
									{
										type: 'text',
										name: 'account_name',
										title: 'Fiók azonosító',
										attributes: {
											onkeypress: 'Anvil.page.name_keypress(event)',
											style: 'text-transform:uppercase;'
										}
									}
								]}
							]}
						]
					}) %>
				</div>
				<div class="card-footer">
					<a href="/login" class="btn btn-light"><i class="fa fa-arrow-left me-2"></i>Vissza</a>
					<button type="button" onclick="Anvil.page.password_reset()" class="btn btn-primary float-end"><i class="fa fa-key me-2"></i>Jelszó visszaállítása</button>
				</div>
			</div>

		</div>
	</div>
</div>

<script>
Object.assign(Anvil.page, {

	name_keypress: (event) => {
		if (event.key == 'Enter') {
			Anvil.page.password_reset()
		}
	},

	password_reset: async function () {
		Anvil.exec('auth/action_forgotten_password', Anvil.models.components.Form.find('#password_reset_form').data)
	}
})
</script>
